import saveBlockContentFromUnknownSendersService from '../services/saveBlockContentFromUnknownSendersService';
import saveFiltersOptionHelper from '../mutators/saveFiltersOptionMutator';
import saveMailboxJunkEmailConfiguration from 'owa-junkmail-configuration/lib/services/setMailboxJunkEmailConfiguration';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';

export default async function saveFiltersOption() {
    // Update local mailboxJunkEmailConfiguration
    saveFiltersOptionHelper();
    const mailboxJunkEmailConfiguration = getMailboxJunkEmailConfiguration();

    // Save trustedListsOnly && contactsTrusted service call
    await saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration);

    // Save blockContentFromUnknownSenders service call
    await saveBlockContentFromUnknownSendersService();
}
